/*
 * @overview: 获取最后一个事件
 * @Created by: zhuyikai
 * @Copyright: Copyright © 2020 找我婚礼. All rights reserved.
 * @Date: 2023-03-27 17:39:42
 */

let lastEvent;
["click", "touchstart", "mousedown", "keydown", "mouseover"].forEach(
  (eventType) => {
    document.addEventListener(
      eventType,
      (event) => {
        lastEvent = event;
      },
      {
        capture: true, // 捕获阶段
        passive: true, // 默认不阻止默认事件
      }
    );
  }
);

export default () => {
  return lastEvent;
};
